import { motion } from 'framer-motion';
import { Animations } from '../../utils/animations';
import { BigTextStyles } from '../../styles/styles';

const BigText = () => {
  const { transition, textReveal } = Animations();
  return (
    <BigTextStyles data-scroll-section className="big-text">
      <div className="container">
        <motion.h1
          variants={textReveal}
          initial="initial"
          animate="animate"
          transition={{ ...transition, delay: 3 }}>
          Eat,
        </motion.h1>
      </div>
      <div className="container">
        <motion.h1
          variants={textReveal}
          initial="initial"
          animate="animate"
          transition={{ ...transition, delay: 3.2 }}>
          sleep,
        </motion.h1>
      </div>
      <div className="container">
        <motion.h1
          variants={textReveal}
          initial="initial"
          animate="animate"
          transition={{ ...transition, delay: 3.4 }}>
          code,
        </motion.h1>
      </div>
      <div className="container">
        <motion.h1
          variants={textReveal}
          initial="initial"
          animate="animate"
          transition={{ ...transition, delay: 3.6 }}>
          repeat.
        </motion.h1>
      </div>
    </BigTextStyles>
  );
};

export default BigText;
